import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-custom-toast',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './custom-toast.component.html',
  styleUrl: './custom-toast.component.css'
})

export class CustomToastComponent extends Toast {
  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
    public translate: TranslateService,
  ) {
    super(toastrService, toastPackage);
  }
}